var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Widget',{attrs:{"className":"mb-xlg pb-2","bodyClass":"task-container mt","title":`
    <div>
      <h4>Today&apos;s Tasks
        <span class='badge rounded-pill bg-primary fw-normal pull-right mt-xs fs-6'>
          ${_vm.tasks.length}
        </span>
      </h4>
      <p class='text-primary mb-0'><small>
        ${_vm.tasks.filter(t => t.completed).length} of ${_vm.tasks.length} completed
      </small></p>
    </div>`,"customHeader":""}},[_vm._l((_vm.tasks),function(task){return _c('Task',{key:task.id,attrs:{"task":task,"completed":task.completed,"toggle":_vm.toggleTaskState}})}),_c('b-button',{staticClass:"bg-white w-100 text-center text-primary",attrs:{"variant":"transparent"}},[_vm._v("\n    See All "),_c('i',{staticClass:"la la-arrow-down"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }